import { CameraOutlined } from '@ant-design/icons';
import { Image, message, Upload } from 'antd';
import getConfig from 'next/config';
import { useState } from 'react';

interface IProps {
  onFileReaded?: Function;
}

export function ImageUploadModel({ onFileReaded }: IProps) {
  const [imageUrl, setImageUrl] = useState('/no-image.jpg');

  const beforeUpload = (file) => {
    const config = require('../../lib/config');
    const isLt5M = file.size / 1024 / 1024 < (config.MAX_SIZE_IMAGE || 20);
    if (!isLt5M) {
      message.error(`Image is too large please provide an image ${config.MAX_SIZE_IMAGE || 20}MB or below`);
      return false;
    }
    setImageUrl(URL.createObjectURL(file));
    onFileReaded && onFileReaded(file);
    return true;
  };

  return (
    <Upload
      customRequest={() => false}
      accept="image/*,.heic,.heif"
      name="file"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      beforeUpload={(file) => beforeUpload(file)}
    >
      <Image
        fallback="/heic-warning.webp"
        preview={false}
        src={imageUrl}
        alt="avatar"
        style={{
          width: 104,
          height: 104,
          borderRadius: '50%',
          objectFit: 'cover',
          overflow: 'hidden'
        }}
      />
      <CameraOutlined />
    </Upload>
  );
}
